module.exports = __webpack_public_path__ + "assets/webgl/LM.5.ec991348.jpg";